export enum eLynxObjectTypeEnum {
    //Invalid = -1,
    None = 0,
    Tag = 1,
    SetPoint = 2,
    Device = 3,
    Recipient = 4,
    NotificationList = 5,
    CommunicationDevice = 6,
    Customer = 7,
    Group = 8,
    User = 9,
    LiquidProductionSet = 10,
    RTSLiveImage = 11,
    CurrentData = 12,
    TagValue = 13,
    Organization = 14,
    Role = 15,
    TankBattery = 16,
    Tank = 17,
    AlarmSchedule = 18,
    AlarmScheme = 19,
    DRCConfigInstance = 20,
    PageConfiguration = 21,
    GroupTrendConfiguration = 22,
    TrendConfiguration = 23,
    TrendingTagAssociationType = 24,
    SummaryListingPage = 25,
    DRCConfigInstanceCollection = 26,
    LookupList = 27,
    TrendConfiguration2 = 28,
    Facility = 29,
    Dynacard = 30,
    Issue = 31,
    AnalyticsConfigurationObjectBridge = 32,
    AccountingingData = 33,
    UnitSet = 34,
    Accounting = 35,
    UserList = 36,
    DRCExtendedConfig = 37,
    ObjectRelationship = 38,
    InjectionPattern = 39,
    InjectionPatternPageConfiguration = 40,
    TankPad = 41,
    Memo = 43,
    MemoAutoText = 44,
    TagThreadType = 45,
    Attribute = 46,
    AttributeValueOption = 47,
    Formulae = 48,
    ApplicationType = 49,
    LookupListText = 50,
    Basin = 51,
    Field = 52,
    Pad = 53,
    Well = 54,
    DeviceConfiguration = 55,
    AnalyticsModelVersion = 56,
    RulesEngineRuleInstance = 57,
    DataFileImportConfiguration = 58,
    RulesEngineRule = 59,
    PollingServerCommunicationsObject = 60,
    PollingServerProtocolObject = 61,
    PlatformObject = 62,
    ObjectTemplate = 63,
    RunTicket = 64,
    HMIViewConfiguration = 65,
    Attachment = 66,
    Image = 67,
    AttributeSchema = 68,
    FormTemplate = 69,
    FormInstance = 70,
    MappingConfiguration = 71,
    DashboardTemplate = 72,
    ObjectTagValuesConfiguration = 73,
}
